import { createStyles } from 'antd-style';

import { ThemeFont, ThemeSpaces } from '../../theme';

export const useShipmentDetailLocalizedDateTimeStyles = createStyles(
  ({ token }) => ({
    localizedDateTime: {
      display: 'flex',
      backgroundColor: token.colorWhite,
      padding: `6px ${ThemeSpaces.SPACE_NORM}px`,

      '.ant-radio-wrapper': {
        fontSize: ThemeFont.FONT_SIZE_SM_PLUS,
      },
    },
    localizedDateTimeTitle: {
      marginRight: ThemeSpaces.SPACE_SM,
      fontSize: ThemeFont.FONT_SIZE_SM_PLUS,
    },
  })
);
